(function() {
	'use strict';

	angular
		.module('app.setup')
		.controller('emailSettings', emailSettings);

	emailSettings.$inject = ['$rootScope', '$scope', '$filter', '$timeout',
		'$compile', '$uibModal', 'factorySettingService', 'storeService'];

	function emailSettings($rootScope, $scope, $filter, $timeout, $compile,
			$uibModal, factorySettingService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var backupValues = {};

		vm.saveSettings = saveSettings;
		vm.resetValues = resetValues;
		vm.changesMade = changesMade;

		vm.onOffOptions = [{
			'display': 'Off',
			'value': 0
		}, {
			'display': 'On',
			'value': 1
		}];
		vm.emailOptions = [{
			'display': 'Off',
			'value': 'Off'
		}, {
			'display': 'On',
			'value': 'Immediate'
		}];

		init();

		function init() {
			factorySettingService.getFactorySettings([
				'EMAIL_ALERT_FREQUENCY',
				'LATE_TASK_AND_ISSUE_EMAIL',
				'MISSING_METRIC_DATE_EMAIL',
				'PM_TASK_ISSUE_EMAIL'
			], adminConfig.factory.id)
			.then(function initDefaultMetricType(settings) {
				vm.emailAlertFrequency = (typeof settings.LATE_TASK_AND_ISSUE_EMAIL !== 'undefined') ? settings.EMAIL_ALERT_FREQUENCY : 'Immediate';
				vm.lateTaskAndIssue = (typeof settings.LATE_TASK_AND_ISSUE_EMAIL !== 'undefined') ? (settings.LATE_TASK_AND_ISSUE_EMAIL ? 1 : 0) : 0;
				vm.missingMetricDate = (typeof settings.MISSING_METRIC_DATE_EMAIL !== 'undefined') ? (settings.MISSING_METRIC_DATE_EMAIL ? 1 : 0) : 0;
				vm.pmTaskAndIssueEmail = (typeof settings.PM_TASK_ISSUE_EMAIL !== 'undefined') ? (settings.PM_TASK_ISSUE_EMAIL ? 1 : 0) : 0;
				backupValues.emailAlertFrequency = vm.emailAlertFrequency;
				backupValues.lateTaskAndIssue = vm.lateTaskAndIssue;
				backupValues.missingMetricDate = vm.missingMetricDate;
				backupValues.pmTaskAndIssueEmail = vm.pmTaskAndIssueEmail;
			});
		}

		function saveSettings() {
			var response = factorySettingService.saveFactorySettings({
				EMAIL_ALERT_FREQUENCY: vm.emailAlertFrequency,
				LATE_TASK_AND_ISSUE_EMAIL: vm.lateTaskAndIssue,
				MISSING_METRIC_DATE_EMAIL: vm.missingMetricDate,
				PM_TASK_ISSUE_EMAIL: vm.pmTaskAndIssueEmail
			}, adminConfig.factory.id).then(function (response) {
				if (response === 'Settings saved successfully') {
					$rootScope.$emit('toast', {
						'message': response,
						'success': true
					});
					backupValues.emailAlertFrequency = vm.emailAlertFrequency;
					backupValues.lateTaskAndIssue = vm.lateTaskAndIssue;
					backupValues.missingMetricDate = vm.missingMetricDate;
					backupValues.pmTaskAndIssueEmail = vm.pmTaskAndIssueEmail;
				} else {
					$rootScope.$emit('toast', {
						'message': response,
						'success': false
					});
				}
			});
		}

		function resetValues() {
			vm.emailAlertFrequency = backupValues.emailAlertFrequency;
			vm.lateTaskAndIssue = backupValues.lateTaskAndIssue;
			vm.missingMetricDate = backupValues.missingMetricDate;
			vm.pmTaskAndIssueEmail = backupValues.pmTaskAndIssueEmail;
		}

		function changesMade() {
			return (
				vm.emailAlertFrequency === backupValues.emailAlertFrequency &&
				vm.lateTaskAndIssue === backupValues.lateTaskAndIssue &&
				vm.missingMetricDate === backupValues.missingMetricDate);
		}
	}
})();
